<div class="grid mt-0 ml-0 align-items-center">
  <div>
    <p-avatar
      [label]="initials"
      styleClass="mr-2"
      [size]="circleSize"
      shape="circle"
      [style]="{ 'background-color': circleColor, color: '#ffffff' }"
    ></p-avatar>
  </div>
  <div *ngIf="showName">
    {{ name }}
    <i *ngIf="icon" [class]="'pi ' + icon" style="font-size: 1rem; margin-left: 5px"></i>
  </div>
</div>
